import { theme } from "src/styles/theme";
import Layout from "src/layout";
import styled from "styled-components";
import { QcastHeader } from "./QcastHeader";
import { QcastSidebar } from "./QcastSidebar";
import { ResponsesPanel } from "./ResponsesPanel";
import QCastContent from "src/pages/Play/QCastContent";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import queryString from 'query-string';

import { useBoundStore } from 'src/store';
import Modal from "src/components/Modal";
import { FiTwitter, FiFacebook, FiLinkedin, FiInstagram } from "react-icons/fi";
import { FaFilePdf } from "react-icons/fa";
import { BsFiletypeXlsx } from "react-icons/bs";
import Loader from "src/components/Loader";
import { getTotalVideoDurationSigngle } from "src/shared/utils/helper";
import ResponseContent from "./ResponseContent";
import QcastApi from "src/store/qcasts/api";
import AccessCodeComponent from "./AccessCodeComponent";
import { usePlayerAccessStore } from "../../store/playerAccess";
// import useASRWorker from "src/hooks/useASRWorker";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  gap: 0px;

`;


const PlayContainer = styled.div<{expand: boolean}>`
  width: ${({ expand }) => (expand ? '100%' : 'calc(100vw - 480px)')};
  height: calc(100svh - 78px);// auto;
  display: flex;
  flex-direction: column;

  gap: 5px;
  border-top-left-radius: 20px;
  padding: 2px 20px 15px 20px;
  border-right-width: 1px;
  background: #F7F7FA;
  @media(max-width: ${theme.breakpoints.maxDesktop}px) { 
    width: 100%; 
    }
    @media (max-width: ${theme.breakpoints.mobile}px) {
      height: calc(100svh - 45px);
  }
`;

const PageContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: start;
  gap: 40px;
  height:100%;
`;


const BackgroundGlow1 = styled.div`
  position: absolute;
  width: 800px;
  height: 800px;
  top: 20%;
  left: 30%;
  background: ${theme.colors.gradients.purpleGlow};
  opacity: 0.15;
  filter: ${theme.blur.heavy};
  z-index: 0;
  pointer-events: none;
`;
const DownloadDIV = styled.div`
font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.regular};
  font-size: ${theme.fontSizes.base};
  color: ${theme.colors.black};
  width:100%;
  justify-content:center;
  align-items:center;
  display:flex;
  gap:30px;
`;
const BackgroundGlow2 = styled.div`
  position: absolute;
  width: 600px;
  height: 600px;
  top: 60%;
  right: 10%;
  background: ${theme.colors.gradients.blueGlow};
  opacity: 0.1;
  filter: ${theme.blur.heavy};
  z-index: 0;
  pointer-events: none;
`;
const BackgroundGlow3 = styled.div<{imgPath: string}>`
  position: absolute;
  width: 800px;
  height: 800px;
  top: 20%;
  left: 30%;
  background-image: url(${props=>props.imgPath});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.15;
  filter: ${theme.blur.heavy};
  z-index: 0;
  pointer-events: none;
`;

const Socials = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 30px;
  justify-content: center;
  align-items: center;
`

const Play = () => {
  const VideoLists: any = [
    {url: "https://qcast.io/static/media/alton_intro.4b99e522.mp4", question: "This is one of the question in this Qcast", comment: 2},
    {url: "https://qcast.io/static/media/alton_q1.b802f90b.mp4", question: "This is one of the question in this Qcast", comment: 3},
    {url: "https://qcast.io/static/media/alton_q2.9b5e43a3.mp4", question: "This is one of the question in this Qcast", comment: 5},
    {url: "https://qcast.io/static/media/alton_q3.150f9d43.mp4", question: "This is one of the question in this Qcast", comment: 3},
    {url: "https://qcast.io/static/media/alton_q4.b94db439.mp4", question: "This is one of the question in this Qcast", comment: 7},
    {url: "https://qcast.io/static/media/alton_q5.23659789.mp4", question: "This is one of the question in this Qcast", comment: 9},
    {url: "https://qcast.io/static/media/alton_q6.fdeb0ef7.mp4", question: "This is one of the question in this Qcast", comment: 3},
    {url: "https://qcast.io/static/media/alton_q7.3366e4fe.mp4", question: "This is one of the question in this Qcast", comment: 7},
    {url: "https://qcast.io/static/media/alton_q8.5df69581.mp4", question: "This is one of the question in this Qcast", comment: 9},
    {url: "https://qcast.io/static/media/alton_q9.b1991e18.mp4", question: "This is one of the question in this Qcast", comment: 9}
  ];

  const [videos, setVideos] = useState<any[]>([]);
  const [moreLikeData, setMoreLikeData] = useState<any[]>([]);
  const [isSocialModalOpen, setIsSocialModalOpen] = useState(false);
  const [socialMedia, setSocialMedia] = useState("");

  const { globalSettings,qcastView,transcription, questions, activityLoader,setResponseVideo,setQcastView, loadQuestions,setQuestions,setQcastLoading,qcastLoading, setQuestionIndex, setExpandSidebar, expandSidebar } = useBoundStore();
  const isNotPC = useMediaQuery({ maxWidth: theme.breakpoints.maxDesktop });
  // const { isModelLoaded, loadModel } = useASRWorker();
  const [hidePannel, setHidePannel] = useState(false);
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const qcastId = urlParams.get('qcastId') || '';
  const authorizedQcastId = usePlayerAccessStore((state) => state.authorizedQcastId);
  const authorizeQcast = usePlayerAccessStore((state) => state.authorizeQcast);
  const isAuth = Boolean(qcastId && authorizedQcastId === qcastId);


  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const loadModels=async()=>{
    try {
      const pathname = window.location.pathname;
     /*  if(pathname.split('/').length > 1){
        const code = pathname.split('/')[1];
        const qcastId = atob(code);
        await loadQuestions(qcastId);
      } */
      
      if(urlParams.has('userId') && urlParams.has('qcastId')){
        const userId = urlParams.get('userId');
        const qcastId = urlParams.get('qcastId');
        const organizationId = urlParams.get('organizationId');
        const interviewId = urlParams.get('interviewId');
        localStorage.setItem("qcastId",qcastId)
        localStorage.setItem("userId",userId)
        if(organizationId){
          localStorage.setItem("organizationId",organizationId)
        }
        if(interviewId){
          localStorage.setItem("interviewId",interviewId)
        }
        await loadQuestions(qcastId, userId);
        const organizationIdForRequest = localStorage.getItem("organizationId");
        if (organizationIdForRequest) {
          const dataMore = await QcastApi.qcastOrgQuery2(userId, organizationIdForRequest);
          setMoreLikeData(dataMore?.data?.mostRecentQcasts || []);
        }
      }
      

    } catch (error) {
      console.error("Error loading model:", error);
    }finally{
      setQcastLoading(false);
    }
  }
  const handleSelectQcast =(index: number)=>{
    setCurrentIndex(index);
  }

  const handleResponse = async()=>{
    await setQuestionIndex(currentIndex);
    navigate("/qcast/respond")
  }

  const handleSocialShare=useCallback((status: boolean)=>{
    setIsSocialModalOpen(status);
  }, []);

  const processQuestions = async() => {

    let response=[]
    let idx=0
    const videoQstn: any = questions && Object.keys(questions).length > 0 && questions?.listOfVideos instanceof Array
    if(videoQstn){
      for(const vid of questions.listOfVideos||[]){
        let durations=await getTotalVideoDurationSigngle(vid)
        response.push(
          {
            url: vid,
            question: questions?.title,
            comment: 0,
            duration:durations,
            maxDuration: questions?.listOfResponsesLimits[idx]
          }
        )
        idx++;
      }
    }
    setVideos(response);
  }


  
  useEffect(() => {
    loadModels();
    

  }, []);


  
  useEffect(()=>{
    if(questions && Object.keys(questions).length > 0){
      processQuestions();
    }
  }, [questions]);

  const handleAuthorized = async (qcast: any) => {
    setQuestions(qcast);
    authorizeQcast(qcastId);

    const userId = urlParams.get('userId');
    const interviewId = urlParams.get('interviewId');
    if (!userId || !interviewId) return;

    try {
      setQcastLoading(true);
      const response = await QcastApi.getResponseDeepCopy(userId, interviewId);
      setQcastView("response");
      setResponseVideo(response.data.responseVideos);
    } catch (error) {
      console.log(error);
    } finally {
      setQcastLoading(false);
    }
  };

const rederDownload=()=>{

 
  switch(window.location.origin){
    case "https://nmsdc25-amazon.qcast.io":
      return <DownloadDIV><div>Download: 1.<a href="/report/Qcast_Analytics_Report_Basic_NMSDC_2025.pdf" target="_blank" download><FaFilePdf/> Qcast Analytics Report (Basic) NMSDC 2025</a></div><div> 2.<a href="/report/19_11_25_Amazon_Qualtrics_Format_Qcast_NMSDC25.xlsx" target="_blank" download><BsFiletypeXlsx/>  Amazon NMSDC 11-19-2025 - Qcast Transcriptions</a></div></DownloadDIV>
      case "https://nmsdc25-quanta.qcast.io":
        return <DownloadDIV><div> 1.<a href="/report/13_11_25_Quanta_NMSDC25_Qcast_Interview_Transcriptions.xlsx" target="_blank" download><BsFiletypeXlsx/>  Quanta NMSDC 11-13-2025 - Qcast Transcriptions</a></div><div> 2.<a href="/report/13_11_25_NMSDC-2025-Quanta-survey_analysis_results.json" target="_blank" download><BsFiletypeXlsx/>   Quanta NMSDC 11-13-2025 - Qcast Survey Analysis</a></div></DownloadDIV>
      case "https://nmsdc25-apple.qcast.io":
        return <></>
      default:
        return <></>
        
  }
}

  return (
    <>

    {isAuth ? (<Layout>
      {qcastLoading && <Loader />}
      <Container>
          
        <PlayContainer expand={expandSidebar && !isNotPC}>
          {rederDownload()}
            
          <QcastHeader 
            qcasterName={questions?.profileName||"Qcast"}
            qseriesName="QSerious Name" 
            avatarSrc= {questions?.coverPhoto} 
            mediaType={socialMedia}
            responders={questions?.qcastResponseList||[]}
            onShare={handleSocialShare} />
          <PageContent>
            {qcastView=="response"?(<ResponseContent/>):(<QCastContent 
              videoLists={videos} 
              selectQcastIndex={currentIndex} 
              onUpdateQcastIndex={handleSelectQcast} 
              onResponse={handleResponse} 
            /> )}
             
          </PageContent>
          
        </PlayContainer>
        {!expandSidebar && !isNotPC && (
          <QcastSidebar 
            title={questions?.title||""}
            videos={videos} 
            transcription={transcription} 
            videoIndex={currentIndex}
            answerCount={questions && questions?.qcastResponseList?.length || 0}
            avatarSrc= {questions?.coverPhoto}
            onSelectQcast={handleSelectQcast}
            onHidePannel={setExpandSidebar}
            moreLikeData={moreLikeData}
          />   
        )}
         
      </Container>
      {isSocialModalOpen && (
        <Modal
          isOpen={isSocialModalOpen}
          onClose={() => setIsSocialModalOpen(false)}
        >
          <div>
              <p style={{fontSize: 20, fontWeight: 500, color: theme.colors.black}}>Share this Qcast on social media</p>
              <Socials>
                <button onClick={()=>setSocialMedia("twitter")}><FiTwitter size={50} /></button>
                <button onClick={()=>setSocialMedia("facebook")}><FiFacebook size={50} /></button>
                <button onClick={()=>setSocialMedia("linkedin")}><FiLinkedin size={50} /></button>
                <button onClick={()=>setSocialMedia("instagram")}><FiInstagram size={50} /></button>
              </Socials>
            </div>
        </Modal>
      )}
    </Layout>):(
      <AccessCodeComponent
        qcastId={qcastId}
        onSubmit={handleAuthorized}
      />
    )}
    </>
    
  );
};

export default Play;